@let userKpisWithTranslations = (userKpisWithTranslations$ | async) || [];

@let resourcesColumnWidthPx =
  assignmentsGanttChartService.resourcesColumnWidthPx$ | async;

<div
  class="kpis-scroll-container"
  [style.width]="
    resourcesColumnWidthPx
      ? resourcesColumnWidthPx - PIXEL_ADJUSTMENT + 'px'
      : '100%'
  "
>
  <div class="kpis-flex-container">
    <ng-container
      *rxFor="
        let kpi of userKpisWithTranslations;
        let isLast = last;
        trackBy: 'translatedName'
      "
    >
      <div
        nz-tooltip
        [nzTooltipTitle]="tooltip"
        class="kpi-parent-container"
        [class.with-divider]="!isLast"
      >
        <span class="kpi-title text-truncate"> {{ kpi.translatedName }} </span>
        <div class="kpi-value">
          @if (!isLoadingKpiValue) {
            @if (kpi.value !== null && kpi.value !== undefined) {
              <div>
                <span class="kpi-text ellipsis">
                  {{ kpi.value }}
                </span>
              </div>
            } @else {
              <span class="kpi-text" nzType="secondary">
                {{ 'general.n/a' | translate }}
              </span>
            }
          } @else {
            <div class="skeleton-loading">
              <nz-skeleton
                [nzActive]="true"
                [nzParagraph]="{ rows: 1 }"
                [nzTitle]="false"
              ></nz-skeleton>
            </div>
          }
        </div>
      </div>
      <ng-template #tooltip>
        <div class="tooltip-content">
          <div class="tooltip-description">
            {{ kpi.translatedDescription }}
          </div>

          <div class="tooltip-value">
            {{ kpi.value }}
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
